import { Outlet } from "react-router-dom"

export default function Bestekken() {
    return (<Outlet />)
}